import React from 'react';
import { Button } from '../components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { finalCtaData } from '../mock/programsData';

const FinalCTA = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="py-20 bg-gradient-to-br from-purple-100 via-pink-100 to-yellow-100"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[2.5rem] border-4 border-purple-300 shadow-2xl bg-gradient-to-br from-pink-300 via-purple-300 to-blue-300 p-10 md:p-16 text-center">
          <div className="absolute -top-10 -right-10 w-48 h-48 bg-yellow-200 rounded-full opacity-40 blur-3xl pointer-events-none"></div>
          <div className="absolute -bottom-10 -left-10 w-48 h-48 bg-pink-200 rounded-full opacity-40 blur-3xl pointer-events-none"></div>

          <div className="relative">
            <div className="inline-flex items-center gap-2 bg-white/60 px-4 py-2 rounded-full mb-6 border-2 border-white">
              <Sparkles className="h-4 w-4 text-purple-700" />
              <span className="text-sm font-bold text-purple-800">Start today</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-extrabold text-purple-900 mb-5 leading-tight">
              {finalCtaData.title}
            </h2>
            <p className="text-base md:text-lg text-purple-800 max-w-2xl mx-auto mb-8 leading-relaxed">
              {finalCtaData.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                data-testid="final-cta-join"
                size="lg"
                onClick={() => scrollTo('programs')}
                className="bg-white text-purple-700 hover:bg-purple-50 font-bold px-8 py-6 text-lg rounded-full border-3 border-white shadow-xl hover:scale-105 transition-all duration-300"
              >
                {finalCtaData.ctaPrimary}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              <Button
                data-testid="final-cta-book"
                size="lg"
                variant="outline"
                onClick={() => scrollTo('contact')}
                className="bg-purple-700 text-white hover:bg-purple-800 hover:text-white font-bold px-8 py-6 text-lg rounded-full border-3 border-purple-700 shadow-xl hover:scale-105 transition-all duration-300"
              >
                {finalCtaData.ctaSecondary}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
